import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <div className="h-screen grid place-items-center"><Loader2 className="h-8 w-8 animate-spin text-electric" /></div>;
  if (!user) return <Navigate to="/owner/login" replace />;
  if (roles && !roles.includes(user.role)) {
    const dest = user.role === "customer" ? "/portal" : user.role === "super_admin" ? "/platform" : "/dashboard";
    return <Navigate to={dest} replace />;
  }
  return children;
}
